/**
 *
 * Custom function
 *
 */ 

(function($) {

	function scrollAnimations() {
		var header = $('#js-header'),
			menu = $('#js-fixed-menu'),
			headerH = header.outerHeight(), // Height compreso di margini e bordi
			menuH = menu.innerHeight(), // Height senza margini e bordi
			scrollValue = $('body').is('.is-mobile') ? headerH : headerH - menuH;

		$(window).scroll(function() {
			scrolltop = $(window).scrollTop();

			if ( scrolltop >= scrollValue) {
				if ( $('body').is('.is-mobile') ) {
					menu.addClass("scroll");
				} else {
					header.addClass("scroll");
				}
			} else {
				if ( $('body').is('.is-mobile') ) {
					menu.removeClass("scroll");
				} else {
					header.removeClass("scroll");
				}
			}            
		});

	}

	/*
	 * Funzione per utilizzare MixItUp da select
	 */

	function filterElements() {
		var filterSelect = '.select-offers',
			container = '.mix-filter-support';

		if ( $(container).length ) {
			/* var mixer = mixitup(container, {
				load: {
					filter: '.estate'
				}
			}); */
			var mixer = mixitup(container);

			$(filterSelect).on('change', function(){
				mixer.filter(this.value);
			});
		}
	}

	// function openModal() {
	// 	if ($('#onloadmodal').length) {
	// 		if (!$.cookie("openmodal")) {
	// 			$('#onloadmodal').modal();
	// 			$.cookie("openmodal", 'no', {
	// 				path: '/'
	// 			});
	// 		}
	// 	}
	// }

	$(document).ready(function() {

		scrollAnimations();

		filterElements();

		// Gestione età bambini
		$('#bambini').on('change', function(){
			var wrapper = $('.age-wrapper');
			var nChildren = $(this).val();
			var maxChildAge = parseInt( $('#form-contatti').data('max-children-age') );

			wrapper.children('select').remove();

			for (var i = 1; i <= nChildren; i++) {
				var selAge = $('<select name="children_age[1][' + i + ']"></select>');
				
				for (var e = 0; e <= maxChildAge; e++) {
					if (e === 0) {
						$('<option value="' + e + '">&lsaquo; 1</option>').appendTo(selAge);
					} else {
						$('<option value="' + e + '">' + e + '</option>').appendTo(selAge);
					}
				}

				wrapper.append(selAge);
			}

			if (nChildren > 0) {
				wrapper.show();
			} else {
				wrapper.hide();
			}
		});

		/* Text lines truncate */
		$('.feedback-list .item .description').collapser({
			mode: 'chars',
			truncate: 220,
			showText: '[ + ]',
			hideText: '[ - ]',
			controlBtn: 'opener',
		});

		/* Equal heights */
		$('.offert-list .item').equalHeights();
		$('.offert-list .item .data').equalHeights();
		
	});


	$(window).load(function() {

		// Aggiustamento per testata fissa
		if ( $('body').is('.is-mobile') ) {
			$('#page').css( 'margin-top', $('.menu-fixed-scroll').outerHeight() );
		} else {
			$('#page').css( 'margin-top', $('#js-header').outerHeight() );
		}

		// $('body').edtModal({
		// 	imageUrl: url.modalUrl + 'pop-up_' + url.modalLang + '.jpg',
		// 	link: ''
		// });

		if( $('body').hasClass('home') ) {
			
			if ($('#onloadmodal').length) {
				$('#onloadmodal').modal('show');
			}

			function startTimer() {
				var presentTime = $('#timer').text();
				var s = presentTime - 1;

				$('#timer').text(s);
				var timer = setTimeout(startTimer, 1000);

				if (s == 0) {
					clearTimeout(timer);
				}
			}

			var delay = 10000;
			var seconds = delay.toString().slice(0, -3);

			$('#timer').text(seconds);
			startTimer();

			setTimeout(function () {
				$('#onloadmodal').modal('hide')
			}, delay);
		}		

	});

	$(window).resize(function() {


	});

})(jQuery);
